import messagesData from './en-US.json';

export const messages: Record<string, string> = messagesData;
